/**
 * Client for the Session Preferences API
 */

import GenericApiClient from '@grantstreet/api-client'

export default class PreferencesApiClient extends GenericApiClient {
  constructor (opts = {}) {
    // Set skipCorrelationId to true to prevent sending X-Correlation-ID headers
    // Amazon API Gateway doesn't support these headers without explicit configuration
    super({
      ...opts,
      skipCorrelationId: true,
    })

    this.apiVersion = 'v1'
    this.baseUrl = opts.baseUrl || 'https://preferences.gsg.tech'
    this.timeout = opts.timeout || 5000
    this.sessionId = opts.sessionId

    this.axios.defaults.headers.post['Content-Type'] = 'application/json'
    this.axios.defaults.timeout = this.timeout
  }

  /**
   * Get preferences for the current session
   * @returns {Promise<Object>} Promise resolving to preferences object
   */
  async getPreferences () {
    return this.get(`/session/${this.sessionId}/preferences`)
  }

  /**
   * Set preferences for the current session
   * @param {Object} preferences - Object containing preferences to set
   * @returns {Promise<Object>} Promise resolving to updated preferences
   */
  async setPreferences (preferences) {
    return this.post(`/session/${this.sessionId}/preferences`, preferences)
  }

  /**
   * Handle 404s gracefully, since they're expected when preferences don't exist yet
   */
  isException (error) {
    return !error.message.includes('Session not found')
  }
}
